import React from "react";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const FoodAndBeveragespopup = ({ data }) => {
  console.log(data);
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
        <AutoDropDown
        classStar="text-red-500"
          title="Food Type"
          Option={[]}
          placeholder="Select"
          name="SubType"
          selectedOption={{ value: data?.FoodType, label: data?.FoodType }}
          Class="custom-class"
          disabled
        />
        <AutoDropDown
        classStar="text-red-500"
          title="Sub FoodType"
          Option={[]}
          selectedOption={{
            value: data?.SubFoodType,
            label: data?.SubFoodType,
          }}
          placeholder="Select"
          name="SubType"
          //content={data?.SubType || ""}
          Class="custom-class"
          disabled
        />
        <InputText
        classStar="text-red-500"
          inputType="text"
          title="Food Name"
          name="FoodName"
          content={data?.FoodName || ""}
          disabled
        />
        <InputText
        classStar="text-red-500"
          inputType="text"
          title="Rate"
          name="Rate"
          content={data?.Rate || ""}
          disabled
        />

        {data.FoodImage && (
                <div className="flex">
                  <div>
                    <img
                      src={data.FoodImage}
                      alt="Image"
                      className="rounded-none w-20 h-20"
                    />
                  </div>
                </div>
              )}
      </div>
    </div>
  );
};

export default FoodAndBeveragespopup;
